import React from 'react';
import styled from 'styled-components';
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';

const FooterContainer = styled.footer`
  width: 100%;
  background: #0a174e;
  color: #fff;
  padding: 36px 0 24px 0;
  font-size: 1.09rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  text-align: center;
`;
const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 1px;
`;
const Logo = styled.img`
  height: 32px;
  width: 32px;
  border-radius: 8px;
  background: #fff;
  padding: 2px;
`;
const Socials = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
`;
const SocialLink = styled.a`
  color: rgba(255,255,255,0.8);
  font-size: 1.5rem;
  transition: color 0.2s, transform 0.2s;
  &:hover {
    color: #25d366;
    transform: translateY(-2px);
  }
  &[aria-label='LinkedIn']:hover {
    color: #0077b5;
  }
  &[aria-label='Instagram']:hover {
    color: #e4405f;
  }
  &[aria-label='Facebook']:hover {
    color: #1877f2;
  }
`;
const Copyright = styled.div`
  font-size: 0.9rem;
  opacity: 0.6;
  margin-top: 4px;
`;

const FooterEn: React.FC = () => (
  <FooterContainer>
    <Brand>
      <span style={{ fontWeight: 700, fontSize: 22, letterSpacing: '0.02em' }}>Wassel</span>
    </Brand>
    <Socials>
      <SocialLink href="https://www.instagram.com/wasseltaxi/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
        <FaInstagram />
      </SocialLink>
      <SocialLink href="https://www.linkedin.com/company/wassel-mobility/" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
        <FaLinkedin />
      </SocialLink>
      <SocialLink href="https://www.facebook.com/wasseltaxi" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
        <FaFacebook />
      </SocialLink>
    </Socials>
    <Copyright>
      © 2025 Wassel. All rights reserved.
    </Copyright>
  </FooterContainer>
);

const FloatingLangSwitch = styled.button`
  position: fixed;
  bottom: 92px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #13245c;
  color: #fff;
  font-weight: 800;
  font-size: 1.08rem;
  border: 2px solid #fff;
  box-shadow: 0 2px 12px rgba(44,62,80,0.13);
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.22s, color 0.22s;
  &:hover, &:focus {
    background: #DA015C;
    color: #13245c;
    outline: none;
  }
`;

const FooterEnWithLangSwitch: React.FC = () => (
  <>
    <FooterEn />
    <FloatingLangSwitch
      aria-label={window.location.pathname.startsWith('/en') ? 'Switch to Arabic' : 'Switch to English'}
      onClick={() => {
        if (window.location.pathname.startsWith('/en')) {
          window.location.href = '/';
        } else {
          window.location.href = '/en';
        }
      }}
    >
      {window.location.pathname.startsWith('/en') ? 'AR' : 'EN'}
    </FloatingLangSwitch>
  </>
);

export { FooterEnWithLangSwitch as default, FooterEn };
